import { Content } from '@angular/compiler/src/render3/r3_ast';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AlertController, ModalController } from '@ionic/angular';
import { GlobalVariable } from '../global';
import { ItemPreviewPage } from '../item-preview/item-preview.page';
import { UserApiService } from '../services/user-api.service';
import { UserPointsPage } from '../user-points/user-points.page';

@Component({
  selector: 'app-rewards',
  templateUrl: './rewards.page.html',
  styleUrls: ['./rewards.page.scss'],
})
export class RewardsPage implements OnInit {
  pointflag: boolean = false;
  punchflag: boolean = false;
  gain_flag: boolean = false;
  points_lotery: any;
  points_Status: any;
  points_reward: any;
  punch_reward: any;
  punchdata: any;
  punch_array: any;
  option: string;
  searchTerm: any = '';
  reward_array: any;
  rewarddata: any;
  flag: boolean = false;
  lotery: any;
  Status: any;
  gain_segment_flag: boolean = false;
  point_segment_flag: boolean = false;
  punchCard_segment_flag: boolean = false;
  gifts_segment_flag: boolean = false;
  arrayStatus: boolean = false;
  coordinates: any;

  // @ViewChild(Content) content: ElementRef
  public selected = 0;
  public indicator = null;
  mySlideOptions: any;
  data: any;
  reward: any;
  udid: any;
  img: any;
  status: boolean = true;
  time: any;
  // searchControl: FormControl;
  business_reward_data: any;
  business_reward_flag: boolean = false;
  redeem_history: boolean = false;
  rewards_length: any;
  point_menu=[]
  point_menu_flag: boolean = false;
  reward_menu=[];
  reward_menu_flag: boolean = false;
  punch_menu=[]
  punch_menu_flag: boolean = false;
  reward_menu_length: any;
  reward_type_home: any;
  cart_reward_view: boolean = false;
  store_points: any;
  image_broken: any;
  sortdata: any = [];
  pointData: any;
  helper: any = [];
  isDataLoaded: boolean=false;
  // segment='points'
  constructor(
    public server: UserApiService,
    public globals: GlobalVariable,
    private alertCtrl:AlertController,
    private modalCtrl:ModalController,
    

  ) {
    console.log(this.globals.punch_check)
    if (this.globals.loyaltySegment == 'points') {
      this.getPoints();
      this.point_items()
    }
    if (this.globals.loyaltySegment == 'punches') {
      this.punch_cards();
    }
    if (this.globals.loyaltySegment == 'rewards') {
      this.rewards_items();
    }
  }

  ngOnInit() {
  }
  segmentChanged(e) {
    this.globals.loyaltySegment = e.detail.value;
    if (this.globals.loyaltySegment == 'points') {
      this.getPoints();
      this.point_items()
    }
    if (this.globals.loyaltySegment == 'punches') {
      this.punch_cards();
    }
    if (this.globals.loyaltySegment == 'rewards') {
      this.rewards_items();
    }
  }
  getReward() {

    let response = this.server.get_all_Rewards_new();
    response.subscribe(data => {
      console.log('all rewardss', data)
      this.lotery = data;
      this.rewards_length = this.lotery.length;
      if (this.lotery.length == 0) {
        this.gain_flag = true;
      }
      else {
        this.gain_flag = false;
      }
      this.lotery.forEach(element => {
        if (element.redeemed == 'yes') {
          this.redeem_history = true;
        }
      });


    }, error => {

      this.globals.presentToast("Something went wrong check your internet connection.")


    });

  }
 
    doRefresh(refresher) {
      
      if (this.globals.loyaltySegment == 'points') {
        this.getPoints();
        this.point_items()
      }
      if (this.globals.loyaltySegment == 'punches') {
        this.punch_cards();
      }
      if (this.globals.loyaltySegment == 'rewards') {
        this.rewards_items();
      }
      console.log(refresher)
      setTimeout(() => {
        console.log('Async operation has ended');
        refresher.target.complete();
      }, 2000);
      // this.content.resize();
      // refresher.complete();
  }
  store_points_fun(){
    this.globals.presentToast("You can avail this discount by adding items in cart.")
}
async points_buy_Confirm(id,type) {
  let alert = await this.alertCtrl.create({
    header: 'Purchase Item',
    message: 'Are you sure.You want to purchase item by points?',
    buttons: [
      {
        text: 'Cancel',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      },
      {
        text: 'Buy',
        handler: () => {
          console.log('Buy clicked');
          this.redeem_point_menu_item(id,type);
        }
      }
    ]
  });
  await alert.present();
}
 async point_model(a){
   const modal=await this.modalCtrl.create({
     component:UserPointsPage,
     breakpoints:[0,0.8],
     initialBreakpoint:0.8,
     mode:'ios',
     cssClass:'pointsModal',
     componentProps:{data:{ title: "Point Detail",terms:a.terms, image: a.image, name: a.name, tagline: a.points_description}}
   })
   modal.present();
        
    }
redeem_point_menu_item(id,type){

  let response = this.server.redeem_point_menu_reward(id,type);
      response.subscribe(data => {          
   
          if(data.status == true){
              this.globals.presentToast(data.message);
              this.getPoints();
              this.punch_cards();
          }
          else{
              this.globals.presentToast(data.message)
          }
          
      
      }
      , error => {
          // loading.dismiss();
          this.globals.presentToast("Something went wrong check your internet connection.")
      });
}
  getPoints() {
    this.server.getPoints().subscribe(data => {
      console.log('points data', data)
      if (data.status == "error") {
        this.globals.points_ = 0;
      }
      else {
        this.globals.points_ = Number(data.rewards[0].points);
        this.store_points = data.rewards[0].available_rewards;
      }
    }, err => {
      this.globals.presentToast("Network error!")
    })
  }
  punch_cards() {
    this.server.getpunches_menuitems().subscribe(data => {
      if (data.status == true) {

        this.punch_menu = data.items;
        if (this.punch_menu.length == 0) {
          this.punch_menu_flag = true;
        }
        else {
          this.punch_menu_flag = false;

        }
        console.log("Punches ", this.punch_menu);
        var i = 0;
        var percent = 0;
        var that = this;
        setTimeout(function () {
          that.punch_menu.forEach(element => {
            percent = (Number(element.punch_count) / Number(element.punch_limit)) * 100;
            that.globals.circle_graph(percent, 'circles' + i, 55, 8, '#ccc');

            console.log(percent, 'circles' + i)
            i++;

          });
        }, 1200);

      }
    }, err => {
      this.globals.presentToast("Network error!")
    })
  }
  getPunchReward() {

    // let loading = this.loadingCtrl.create({
    //     content: "Loading...",

    // });

    let response = this.server.GetPunchcards(this.coordinates);
    // loading.present();

    response.subscribe(data => {
       // this.globals.circle_graph(this.globals.percent,'circles1',150,20,'#fff');

        this.data.response = data;
        this.punch_reward = this.data.response;
        console.log("mypunch",data);
        // loading.dismiss();
        console.log(this.punch_reward.success);

        if (this.punch_reward.success == "No data") {
            this.punchflag = true;

        }

        else {
            this.punchflag = false;
            this.punchdata = this.punch_reward.cards;

            this.punchdata.forEach(element => {
                if (element.punch_reward_4 != '') {
                    element.lowestreward = element.punch_reward_4;
                    return;

                }
                else if (element.punch_reward_8 != '') {
                    element.lowestreward = element.punch_reward_8;
                    return;
                }
                else if (element.punch_reward_10 != '') {
                    element.lowestreward = element.punch_reward_10;
                    return;
                }
                else if (element.punch_reward_12 != '') {
                    element.lowestreward = element.punch_reward_12;
                    return;
                }

            });

            this.punch_array = this.punchdata;
            console.log(this.punchdata);

        }
    }, error => {
        console.log("Oooops!");
        // loading.dismiss();
        this.globals.presentToast("Something went wrong check your internet connection.")

    });

}
  rewards_items() {
this.isDataLoaded=false;
    let response = this.server.getrewards_menuitems();
    response.subscribe(data => {
      this.isDataLoaded=true;

      if (data.status == true) {
        this.reward_menu = data.items;
        this.reward_menu_length = this.reward_menu.length;
        this.reward_menu.forEach(subelement => {
          subelement.quantity = 1;

        });
        if (this.reward_menu.length == 0) {
          this.reward_menu_flag = true;
        }
        else {
          this.reward_menu_flag = false;
        }
      }
      else {
        this.reward_menu_flag = true;
      }


    }
      , error => {

        this.globals.presentToast("Something went wrong check your internet connection.")
      });
  }
  point_items() {

    this.sortingArray();

    let response = this.server.getpoints_menuitems();
    response.subscribe(data => {

      if (data.status == true) {
        this.point_menu = data.items;
        this.point_menu.forEach(subelement => {
          subelement.quantity = 1;
          var result = subelement.point_price.replace(/,/g, "");
          subelement.rmstring = parseInt(result);
          if (Number(result) > Number(this.globals.points_)) {
            subelement.disable_btn = true;
          } else {
            subelement.disable_btn = false;
          }
        });
        this.helper.arr.multisort(this.point_menu, ['rmstring'], ['ASC']);

        if (this.point_menu.length == 0) {
          this.point_menu_flag = true;
        } else {
          this.point_menu_flag = false;
        }
      }
      else {
        this.point_menu_flag = true;
      }


    }
      , error => {
        // loading.dismiss();
        this.globals.presentToast("Something went wrong check your internet connection.")
      });
  }
  sortingArray() {
    this.helper.arr = {

      multisort: function (arr, columns, order_by) {
        if (typeof columns == 'undefined') {
          columns = []
          for (var x = 0; x < arr[0].length; x++) {
            columns.push(x);
          }
        }

        if (typeof order_by == 'undefined') {
          order_by = []
          for (x = 0; x < arr[0].length; x++) {
            order_by.push('ASC');
          }
        }

        function multisort_recursive(a, b, columns, order_by, index) {
          var direction = order_by[index] == 'DESC' ? 1 : 0;

          var is_numeric = !isNaN(a[columns[index]] - b[columns[index]]);

          var x = is_numeric ? a[columns[index]] : a[columns[index]].toLowerCase();
          var y = is_numeric ? b[columns[index]] : b[columns[index]].toLowerCase();

          if (!is_numeric) {
            x = this.helper.string.to_ascii(a[columns[index]].toLowerCase(), -1),
              y = this.helper.string.to_ascii(b[columns[index]].toLowerCase(), -1);
          }

          if (x < y) {
            return direction == 0 ? -1 : 1;
          }

          if (x == y) {
            return columns.length - 1 > index ? multisort_recursive(a, b, columns, order_by, index + 1) : 0;
          }

          return direction == 0 ? 1 : -1;
        }

        return arr.sort(function (a, b) {
          return multisort_recursive(a, b, columns, order_by, 0);
        });
      }
    }

  }
  async openItem(menuitem,extras,reward_id){
    this.globals.businessMenuItem=menuitem;
    this.globals.itemDetail=menuitem
 
      const modal = await this.modalCtrl.create({
      component: ItemPreviewPage,
      componentProps: { data: menuitem ,extrasObtained:extras,reward_id_new:reward_id}
      });
    
      await modal.present();
    
      const data = await modal.onDidDismiss();
      console.log(data)
    
 

    //  this.router.navigate(['/item-preview']);

  }
async punch_model(rewards){
  // let modal = this.modalCtrl.create('PointPunchModelPage', { title: "Punch Detail",terms:rewards.terms,tagline:rewards.punch_description, udid:rewards.id, name:rewards.name, image: rewards.image, punch_count: rewards.punch_count, punch_limit: rewards.punch_limit});

    const modal=await this.modalCtrl.create({
      component:UserPointsPage,
      breakpoints:[0,0.8],
      initialBreakpoint:0.8,
      mode:'ios',
      cssClass:'pointsModal',
      componentProps:{data:{ title: "Punch Detail",terms:rewards.terms,tagline:rewards.punch_description, udid:rewards.id, name:rewards.name, image: rewards.image, punch_count: rewards.punch_count, punch_limit: rewards.punch_limit}}
    })
    modal.present();
         
     
}
}
